<template>
    <div class="div" v-loading.fullscreen.lock="allLoading">
        <div class="div-c">
            <div class="title">
                <img src="../../assets/logo.png" alt="">
                <h1>{{title}}</h1>
            </div>
            <div class="content">
                <div class="sidebar">
                    <div v-for="items in ksArray" :key="items">
                        <div class="sidebarTitle" v-show="urlPrefix != 'tengzhou'">{{items}}</div>
                        <div class="sidebarList ellipsis" v-for="item in sidebar" :key="item.id" @click='getDivList(item)' :class="{active:show == item.id}">
                            <span v-if="specialArr.indexOf(query.code) != -1 && sidebar.find(e=>e.customKind)">
                                <span v-if="items == item.customKind">{{item.name}}</span>
                            </span>
                            <span v-else>
                                <span v-if="items == item.ksName">{{item.name}}</span>
                            </span>
                            
                        </div>
                    </div>
                </div>
                <div class="main">
                    <div class="navigation ellipsis">
                        您现在的位置:
                        <span class="navigationBar" @click="goBack">首页</span> /
                        <span class="navigationBar" v-show="urlPrefix != 'tengzhou'">{{navigationKsName}} / </span>
                        <span class="navigationBar " style="color:#2D8CC3">{{navigationName}}</span>
                    </div>
                    <div class="main-c">
                        <div class="mainTitle ellipsis">
                            {{main.name}}
                        </div>
                        <div class="mainList">
                            <div class="list" v-for="item in mainList" :key="item.id" @click="goDetail(item.id)">
                                <span class="ellipsis">{{item.titleName}}</span>
                                <span class="ellipsis" style="color: #9F9FA5;">{{item.gksj}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getPublic, publicDivs } from '@/api/public.js'
    export default {
        name: "index",
        data() {
            return {
                allLoading: true,
                pdfName: "",
                htmlurl: window.location.origin,
                linkName: false,
                divname: '',
                gksj: '',
                title: '',
                query: {
                    code: '',
                    year: '',
                    type: '',
                },
                ksArray: [],
                sidebar: [],  //侧边栏
                main: [],  //主体
                mainList: [],  //主体列表
                show: -1,
                navigationKsName: '',
                navigationName: '',
                dw: '',
                bm: '',
                urlPrefix:'',
                openType:this.$store.state.openType == 'js' ? '决算' : '预算',
                specialArr:['decheng','pingyuan','laoling','lingcheng','xiajin','linyi']
            }
        },
        async created() {
            this.divid = this.$route.query.id;
            this.getYear();
            await this.init();
             let host = window.location.host;
            this.urlPrefix = host.slice(0, host.indexOf("."))
        },
        methods: {
            async init() {
                let publicRes = await getPublic(this.query)
                if (publicRes.status == '9aa5e47366e74320a934e8ea8124db98') {
                    this.goBack()
                } else {
                    this.allLoading = true;
                    if (publicRes.status == 0) {
                        this.title = `${publicRes.name}${this.query.year}年部门${this.openType}公开`
                        publicRes.gksj.forEach(ele => {
                            if (ele.divtype == 0) {
                                this.dw = ele.date.substring(0, ele.date.indexOf('T'))
                            } else if (ele.divtype == 2) {
                                this.bm = ele.date.substring(0, ele.date.indexOf('T'))
                            }
                        })
                    }
                    let res = await publicDivs(this.query);
                    if (res.status == 0) {
                        if (this.specialArr.indexOf(this.query.code) != -1 && res.divs.find(e=>e.customKind)) {
                            res.divs.forEach(ele => {
                                if (ele.customKind) {
                                    this.ksArray.push(ele.customKind)
                                }
                                ele.children = []
                            })
                        } else {
                            res.divs.forEach(ele => {
                                this.ksArray.push(ele.ksName)
                                ele.children = []
                            })
                        }
                        this.ksArray = Array.from(new Set(this.ksArray))
                        let obj = {};
                        this.ksArray.forEach((item, index) => {
                            if (item === '行政政法科') {
                                obj = item;
                                this.ksArray.splice(index, 1)
                                return;
                            }
                        })
                        if (obj.length) {
                            this.ksArray.unshift(obj);
                        }
                        for (let i = res.divs.length - 1; i >= 0; i--) {
                            if ((res.divs[i].bmName)) {
                                let a = res.divs.find(item => item.name == res.divs[i].bmName)
                                if (a && publicRes.name != '聊城市') { //聊城不展示二级单位
                                    a.children.push(res.divs[i])
                                    a.children.sort(function (a, b) {
                                        return a.code - b.code
                                    })
                                }
                                res.divs.splice(i, 1)
                                this.childrenType = true //如果有children,开关打开
                            }
                        }
                        res.divs.forEach(ele => {
                            if (ele.children.length == 0) {
                                delete ele.children
                            }
                        })
                        let initial = res.divs.filter(item => item.id == this.divid)
                        if (initial.length != 0) {
                            this.getDivList(initial[0])
                        }
                        this.sidebar = res.divs.filter(item => item.type == 2)
                        this.$nextTick(() => {
                            document.getElementsByClassName('sidebarList').forEach(ele => {
                                if (ele.innerText.length == 0) {
                                    ele.style.display = 'none'
                                }
                            })
                        })
                    }
                    this.allLoading = false;
                }
            },
            async getDivList(item) {
                this.show = item.id
                this.main = item
                if (this.specialArr.indexOf(this.query.code) != -1 && this.sidebar.find(e=>e.customKind)) {
                    this.navigationKsName = item.customKind
                } else {
                    this.navigationKsName = item.ksName
                }
                this.navigationName = item.name
                this.mainList = []
                this.mainList.push(this.main)
                if (this.main.children) {
                    this.main.children.forEach(ele => {
                        this.mainList.push(ele)
                    })
                }
                this.mainList.forEach(ele => {
                    let name = ele.name
                    if (ele.type == 0) {
                        let name = ele.name
                        ele.gksj = this.dw
                        ele.titleName = `${this.query.year}年度${name}${this.openType}`
                    } else {
                        ele.gksj = this.bm
                        ele.titleName = `${this.query.year}年度${name}部门${this.openType}`
                    }
                })
            },
            getYear() {
                let host = window.location.host;
                let prefix = host.split(".")[1];
                this.query.code = host.split(".")[0]
                this.query.year = '20' + prefix.substring(0, 2);
                this.query.type = prefix.substring(2, 4)
            },
            goBack() {
                this.$router.push({ name: '公开页面' })
            },
            goDetail(id) {
                let url = this.$router.resolve({ name: '公开页面详情页面', query: { id: id } })
                window.open(url.href, '_blank')
            },
        },
    };
</script>
<style scoped>
    .div {
        background: url(../../assets/bg.png) no-repeat center;
        height: 100%;
        width: 100%;
    }

    .gksj {
        margin-left: 50px;
        display: block;
    }

    .div-c {
        width: 80%;
        height: 100%;
        margin: 0 auto;
    }

        .div-c .title {
            width: 100%;
            height: 15vh;
            display: flex;
            align-items: center;
            padding-left: 10px
        }

            .div-c .title h1 {
                color: #fff;
                font-weight: normal;
                font-size: 24px;
            }

    .content {
        width: 100%;
        height: 83vh;
        display: flex;
    }

        .content .sidebar {
            height: 100%;
            width: 300px;
            background: #fff;
            border: 1px solid #E8E8EF;
            box-shadow: 0px 0px 3px 1px rgb(72 76 90 / 10%);
            overflow: auto;
        }

            .content .sidebar .sidebarList {
                width: 80%;
                margin: 0 auto;
                height: 46px;
                line-height: 46px;
                text-align: center;
                cursor: pointer;
                margin-top: 10px;
            }

    .sidebarList:hover {
        color: #BD1A2D
    }

    .active {
        color: #fff;
        background: #BD1A2D
    }

        .active:hover {
            color: #fff;
        }

    .content .sidebar .sidebarTitle {
        width: 100%;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #E8E8EF;
        color: #BD1A2D;
        font-size: 18px;
        font-weight: bold;
    }

        .content .sidebar .sidebarTitle:before {
            content: "";
            width: 3px;
            height: 17px;
            background: #bd1a2d;
            margin: 18px 7px 0 10px;
            float: left;
        }

    .content .main {
        height: 100%;
        width: calc(100% - 220px);
        margin-left: 20px;
        border: 1px solid #E8E8EF;
        box-shadow: 0px 0px 3px 1px rgb(72 76 90 / 10%)
    }

    .main .navigation {
        height: 49px;
        width: calc(100% - 20px);
        line-height: 50px;
        background: #F6F7FB;
        padding-left: 20px;
        border-bottom: 1px solid #E8E8EF;
    }

    .navigationBar {
        cursor: pointer;
    }

        .navigationBar:hover {
            color: #2D8CC3
        }

    .main .main-c {
        height: calc(100% - 50px);
        background: #fff;
    }

    .main-c .mainTitle {
        height: 39px;
        line-height: 39px;
        padding-left: 10px;
        border-bottom: 1px solid #E8E8EF;
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }

    .main-c .mainList {
        height: calc(100% - 40px);
        overflow: auto;
    }

    .mainList .list {
        height: 40px;
        line-height: 40px;
        padding: 0 25px;
        display: flex;
        justify-content: space-between;
    }

        .mainList .list:hover {
            color: #BD1A2D;
            cursor: pointer;
        }

    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>